(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaTransfReception', PharmaTransfReception);

	PharmaTransfReception.$inject = [ '$resource' ];

	function PharmaTransfReception($resource) {
		var resourceUrl = 'api/pharma-transf-reception/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'save' : {
				method : 'PUT',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			},
			'submit' : {
				method : 'GET',
				url : 'api/pharma-transf-reception/:id/submit',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
